import React, { lazy, Suspense } from 'react';
import Navigation from './components/navigation/Navigation';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { generateRoutesForNavBarMenu } from './functions/RoutesConfig';
import narBarMenuData from './data/json/common_data/NavBarMenu.json';
import Home from './pages/home/Home';
import Footer from './components/footer/Footer';
import ScrollToTop from './functions/ScrollToTop';
import { useEffect, useState } from 'react';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';

// Reusable hook to prevent pull-to-refresh
const usePreventPullToRefresh = () => {

  useEffect(() => {
    let startY = 0;

    const touchStartHandler = (e: TouchEvent) => {
      if (window.scrollY === 0) {
        startY = e.touches[0].clientY;
      }
    };

    const touchMoveHandler = (e: TouchEvent) => {
      if (window.scrollY === 0 && e.touches[0].clientY > startY) {
        e.preventDefault(); // Prevent pull-to-refresh
      }
    };

    document.addEventListener('touchstart', touchStartHandler, { passive: false });
    document.addEventListener('touchmove', touchMoveHandler, { passive: false });

    return () => {
      document.removeEventListener('touchstart', touchStartHandler);
      document.removeEventListener('touchmove', touchMoveHandler);
    };
  }, []);
};


const App: React.FC = () => {

  // Use the pull-to-refresh prevention hook
  usePreventPullToRefresh();

  return (
    <>
      <Router>
        <Navigation />
        <ScrollToTop />

        {/* --If wants to add any specific routes
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes> */}
        {/* {generateRoutesForNavBarMenu(narBarMenuData.menu)} */}

        <Suspense fallback={<LoadingSpinner message="Loading..." />}>
          <Routes>
            {generateRoutesForNavBarMenu(narBarMenuData.menu)}
          </Routes>
        </Suspense>
        <Routes>
          {/* <Route path="*" element={<Home />} /> */}
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;

